import { render, staticRenderFns } from "./XmImgUpload.vue?vue&type=template&id=04d7d4ee&scoped=true"
import script from "./XmImgUpload.vue?vue&type=script&lang=js"
export * from "./XmImgUpload.vue?vue&type=script&lang=js"
import style0 from "./XmImgUpload.vue?vue&type=style&index=0&id=04d7d4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7d4ee",
  null
  
)

export default component.exports